'use client';
import Link from 'next/link';
import { useEffect } from 'react';
import Bugsnag from '@bugsnag/js';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

export const metadata = {
  title: 'Error - ScalePracticer',
  description: 'An error occurred while loading the page.',
  canonical: 'https://scalepracticer.app/error',
};

const ErrorPage = ({ error }) => {
  useEffect(() => {
    const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;

    if (!apiKey) return;

    Bugsnag.notify(error);
  }, [error]);

  return (
    <section className="flex flex-col justify-center items-center text-center min-h-[calc(100vh-112px)]">
      <div className="flex flex-col justify-center items-center px-6 py-12 mb-4 shadow-md rounded-md border m-4 md:m-0 ">
        <ExclamationTriangleIcon className="text-yellow-400 size-48" />
        <h1 className="text-3xl font-bold mt-4 mb-2">Something went wrong</h1>
        <p className="text-gray-500 text-xl mb-10">{error.toString()}</p>
        <Link
          href="/"
          className="btn btn-outline btn-warning btn-md text-white"
        >
          Go Home
        </Link>
      </div>
    </section>
  );
};

export default ErrorPage;
